export default __webpack_public_path__ + "locales/tr/Common.json?hash=af50a0a37167caf6bbf28164b791f863";